import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [
    { path: '/', name: 'protocolandrules', component: r => { require(['./protocolandrules/protocolandrules'], r) }, meta: { title: '' }}
]

export default new VueRouter({
    routes: routes
})